<!-- 饼图 -->
<style lang="stylus" scoped>
.pie {
  width: 100%;
  height: 30vh;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="pie">
      <div class="main"></div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from '../common/boxWrap';
export default {
  props: ['distributedBar'],
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {},
      name: '贫困户分布',
      dataX: [],
      chartData: []
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    var count = 0
    for (var i = 0; i < this.distributedBar.length; i++) {
      if (this.distributedBar[i].regionName && count < 8) {
        // this.dataX.push(this.distributedBar[i].regionName)
        if (this.distributedBar[i].regionName.indexOf('县') > -1) {
          this.dataX.push(this.distributedBar[i].regionName.split('县')[1])
        } else {
          this.dataX.push(this.distributedBar[i].regionName)
        }
        this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
        count++
      }
    }
    // console.log(this.chartData)
    const data = this.chartData;
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.pie .main'));
    this.myChart.setOption({
      title: {
        show: false
      },
      legend: [{
        orient: 'vertical',
        left: '5',
        top: '5',
        data: this.dataX,
        textStyle: {
          color: "#00fefb",
          fontSize: 14
        }
      }],
      toolbox: {
        show: false
      },
      color: this.color,
      series: [
        {
          name: '访问来源',
          type: 'pie',
          radius: ['30%', '60%'],
          center: ['65%', '55%'],
          data,
          label: {
            position: 'outside'
          },
          labelLine: {
            show: true
          },
          itemStyle: {
            position: 'outside',
            normal: {
              label: {
                show: true,
                fontSize: 14,
                position: 'outside',
                formatter: '{d}',
                color: "#fff"
              },
              labelLine: {
                show: true
              }
            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    });
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?79671320